import React, {useState, useEffect} from 'react';
import { motion, useScroll } from 'framer-motion';
import { Image, Button } from 'react-bootstrap';


import './features.css';
import './responsive.css';


const Features = () => {
    const art = require('../assets/images/art.png');
    const dance = require('../assets/images/dance.png');
    const artistsvariety = require('../assets/images/artistsvariety.png');
    const sunsetpeople = require('../assets/images/sunsetpeople.png');
    const jamchat = require('../assets/images/jamchat.png');
    const audiooverlay = require('../assets/images/audiooverlay.png');
    const calendarlp = require('../assets/images/calendarlp.png');
    
    const feature3 = require('../assets/images/play.png');

    return(
        <div className='features-container'>
            <h1 className='features-header'>
                Upcoming App Add Ons
            </h1>
            
            <div className='feature-wrapper'>
                <div className='feature'>
                    <Image src={jamchat}/>
                    <h1>
                    Random Musician Group Chat
                    </h1>
                    <h2>
                    Randomly Assign 3-5 Users To A Group Chat To Share Ideas And Collaborate
                    </h2>
                </div>
                <div className='feature'>
                    <Image src={audiooverlay}/>
                    <h1>
                    Audio Overlay Collaboration Tool
                    </h1>
                    <h2>
                    Users Can Send Audio Files To Eachother, Record Over It, And 
                    Send It Back 
                    </h2>
                </div>
                <div className='feature'>
                    <Image src={calendarlp}/>
                    <h1>
                    Events For Promotion And Community
                    </h1> 
                    <h2>
                    
                    The Team At ArtSeen Will Host Weekly Events For Musicians
                    </h2>
                </div>
            </div>

        </div>
        

    );

};

export default Features;